import React from "react";
import NutzungHeatmapGrid from "./NutzungHeatmapGrid.jsx";
import NutzungWidget from "./NutzungWidget.jsx";

/** Arbeitszeitmuster - dieselbe Wochentag×Stunde-Form wie die Heatmap im
 * Überblick ({wochentag 1-7, stunde 0-23, wert}), hier auf den einzelnen
 * Mitarbeiter bezogen (Feld "muster" aus /nutzung/daten/profil/{user}). */
export default function NutzungProfilMuster({muster, loading, error}) {
    const rows = Array.isArray(muster) ? muster : [];
    const hatWerte = rows.some((row) => row.wert > 0);

    return (
        <NutzungWidget
            title="Arbeitszeitmuster"
            help="Wann dieser Mitarbeiter im gewählten Zeitraum am meisten aktiv war."
            loading={loading}
            error={error}
            empty={!loading && !error && !hatWerte}
            height={240}
        >
            <NutzungHeatmapGrid rows={rows} />
        </NutzungWidget>
    );
}
